export default "__VITE_ASSET__CpTxh6Jb__"